import { Rpc } from "rpc/rpc";
import { MetaVacationTypeDto } from "rpc/meta";
import { ValueWrapper } from "rpc/ValueWrapper";


export class VacationTypesRpc {

    public static save(vacationTypes: MetaVacationTypeDto[]): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/vacationtypes/save", {
            vacationTypes: vacationTypes
        });
    }

    private constructor() {}

}